<template>
  <vxe-column v-if="isUnit" title="数量" field="creditQuantity" align="right" width="90">
    <template #default="{row}">
      <!-- && row.unit   如果不是数量核算的科目,数量禁用jxd -->
      <vxe-input @blur="valChange(row,'yearTotalCreditQuantity')" v-if="canEdit(row) && row.unit" type="number" align="right" v-model.number="row.yearTotalCreditQuantity" :controls="false" size="mini"/>
      <!-- jxd回显数量 a-->
      <span v-else>{{ row.yearTotalCreditQuantity || '' }}</span>
    </template>
  </vxe-column>
  <vxe-column v-if="isFor&&!isLocal" title="原币" field="yearTotalCreditFor" align="right" width="120">
    <template #default="{row}">
      <vxe-input @blur="valChange(row,'yearTotalCreditFor')" v-if="canEdit(row)" type="number" align="right" v-model.number="row.yearTotalCreditFor" :controls="false"/>
      <span v-else>{{ row.yearTotalCreditFor || '' }}</span>
    </template>
  </vxe-column>
  <vxe-column :title="colTitle" field="yearTotalCredit" align="right" width="120">
    <template #default="{row}">
      <vxe-input @blur="valChange(row,'yearTotalCredit')" v-if="canEdit(row)" type="number" align="right" v-model.number="row.yearTotalCredit" :controls="false"/>
      <span v-else>{{ row.yearTotalCredit || '' }}</span>
    </template>
  </vxe-column>
</template>

<script>
/**
 * <p>****************************************************************************</p>
 * <p><b>Copyright © 2019-2020金华企客观网络科技有限公司All Rights Reserved<b></p>
 * <ul style="margin:15px;">
 * <li>Description : </li>
 * <li>Version     : 1.0</li>
 * <li>Creation    : 2020年08月08日</li>
 * <li>@author     : ____′↘企万慧</li>
 * </ul>
 * <p>****************************************************************************</p>
 */
export default {
  name: "TotalCreditCol",
  props: {
    valChange: Function,
    isStartYear: Boolean,
    isUnit: Boolean,
    beginCheck: Boolean,
    isFor: Boolean,
    isLocal: Boolean,
    currencyName: String,
  },
  computed: {
    colTitle() {
      if (this.isFor) {
        return '本位币';
      }
      return this.isUnit ? '金额' : '贷方累计'
    }
  },
  methods: {
    canEdit(row) {
      //如果是1月启用的账套，是不需要录入借方累计，贷方累计的jxd，所以这里要加上是否是1月的判断
      //去除是否是isStartYear(是否是年初1月份,不知道为何在在这加这个判断)的条件判断
      //row.auxiliaryDetailId !== '0' ||这个条件应该去掉，因为即使是辅助核算的科目，他起初是否能进行填写，和普通科目的判断是一样的，不需要过滤掉辅助核算
      return !this.beginCheck && ((row.leaf && !this.isStartYear)) && (row.auxiliaryDetailId !== '0' || (row.leaf && row.auxiliaryAccounting.length === 0)) && this.currencyName!=='综合本位币'
      // return !this.beginCheck && (row.auxiliaryDetailId !== '0' || (row.leaf && row.auxiliaryAccounting.length === 0)) && this.currencyName!=='综合本位币'
    }
  },
}
</script>
